import styled from 'styled-components';
import { StyledTypeAheadFlyout } from './TypeAheadFlyout/TypeAheadFlyout.styles';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

const { color, mediaQuery, font } = baseVariables;

export const StyledDestination = styled.div`
  height: 100%;

  .flyout-container {
    .show-flyout-scrollable {
      height: 100%;
    }
  }

  @media ${mediaQuery.lg} {
    .flyout-container {
      .show-flyout-scrollable {
        height: fit-content;
        position: absolute;
        top: ${toRem(55)};
        width: 100%;
        z-index: 100;
        box-sizing: border-box;
        border-radius: ${toRem(8)};
        background-color: ${color.merch50};
        box-shadow: 0 ${toRem(7)} ${toRem(20)} 0 rgba(0, 0, 0, 0.25);
        min-width: ${toRem(345)};
      }
    }

    ${StyledTypeAheadFlyout} {
      .type-ahead-flyout {
        overflow: hidden;
        padding-left: 0 !important;
      }

      &:not(.type-ahead-flyout) {
        .MuiAutocomplete-paper {
          display: none;
        }
      }

      &.search-page-destination {
        width: 100%;
        padding: 0;
        .MuiInputBase-formControl {
          .MuiAutocomplete-endAdornment {
            color: ${color.base10};
            right: ${toRem(6)};
            .icon-cancel {
              color: ${color.base10};
            }
          }
        }
      }
    }
    position: relative;
  }
  .MuiFormHelperText-root {
    &.Mui-error {
      font-weight: ${font.fontWeightRegular};
    }
  }
`;
